import { z } from "zod";
import { ShortText, idString } from "./common.js";
const ParetoBar = z
    .object({
    id: idString,
    label: ShortText,
    value: z.number().finite().nonnegative(),
})
    .strict();
/**
 * Pareto — Look. Used by both `paretoL1` (broad cut) and `paretoL2`
 * (drilldown). The Component sorts descending by value and overlays a
 * cumulative-% line via recharts `ComposedChart`.
 */
export const ParetoParamsSchema = z
    .object({
    title: ShortText.optional(),
    unit: ShortText.optional(),
    bars: z.array(ParetoBar).max(50),
})
    .strict();
export const defaultParetoParams = {
    unit: "",
    bars: [],
};
// Re-export the same schema under the L1 / L2 instance names so the
// registry can distinguish the two kinds while the Component stays one.
export const ParetoL1ParamsSchema = ParetoParamsSchema;
export const ParetoL2ParamsSchema = ParetoParamsSchema;
export const defaultParetoL1Params = defaultParetoParams;
export const defaultParetoL2Params = defaultParetoParams;
//# sourceMappingURL=pareto.js.map